import { Component, Element, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'mama-contact',
  styleUrl: './mama-contact.scss',
})
export class MamaContact {
  @Element() el!: HTMLElement;

  @Prop() uid: string;

  @Listen('click')
  openModal(event) {
    if (event.target.classList.contains('show-more')) {
      const detail = document.createElement('mama-contact-detail');
      Object.assign(detail, { uid: this.uid });

      document.body.appendChild(detail);
    }
  }
}
